const SEARCH_RINGS = 8;
export function placeQuestKeepers(keepers, places, grid, taken) {
    const used = new Set(taken.map((tile) => `${String(tile.x)}:${String(tile.y)}`));
    const spawns = [];
    for (const keeper of keepers) {
        const place = places.find((candidate) => candidate.name === keeper.near);
        if (place === undefined)
            throw new Error(`Quest keeper ${keeper.mob}: no place "${keeper.near}"`);
        const want = { x: place.x + keeper.dx, y: place.y + keeper.dy };
        let spot;
        for (let ring = 0; ring <= SEARCH_RINGS && spot === undefined; ring += 1) {
            for (let dy = -ring; dy <= ring && spot === undefined; dy += 1) {
                for (let dx = -ring; dx <= ring && spot === undefined; dx += 1) {
                    if (Math.max(Math.abs(dx), Math.abs(dy)) !== ring)
                        continue;
                    const tile = { x: want.x + dx, y: want.y + dy };
                    const key = `${String(tile.x)}:${String(tile.y)}`;
                    if (!grid.isWalkableTile(tile) || used.has(key))
                        continue;
                    spot = tile;
                    used.add(key);
                }
            }
        }
        if (spot === undefined) {
            throw new Error(`Quest keeper ${keeper.mob}: no open tile near "${keeper.near}"`);
        }
        spawns.push({
            mob: keeper.mob,
            ...spot,
            count: keeper.count ?? 1,
            radius: keeper.radius ?? 0,
            ...(keeper.facing !== undefined ? { facing: keeper.facing } : { facing: 'south' }),
            // A quest's quarry is each player's own, while the quest is under way.
            ...(keeper.during !== undefined ? { personal: true, during: keeper.during } : {}),
        });
    }
    return spawns;
}
//# sourceMappingURL=quest-keepers.js.map